import { CommonTriggerDataAttributes } from "../../utils/popupStateMapping.mjs";
export let TooltipTriggerDataAttributes = function (TooltipTriggerDataAttributes) {
  /**
   * Present when the corresponding tooltip is open.
   */
  TooltipTriggerDataAttributes[TooltipTriggerDataAttributes["popupOpen"] = CommonTriggerDataAttributes.popupOpen] = "popupOpen";
  /**
   * Present when the trigger is disabled, either by the `disabled` prop or by a parent `<Tooltip.Root>` component.
   */
  TooltipTriggerDataAttributes["triggerDisabled"] = "data-trigger-disabled";
  return TooltipTriggerDataAttributes;
}({});